export type TransferTime = {
  id: string
  key: string
  min: number
  max: number
}

export function getTransferTime(time: { min: number; max: number }): TransferTime {
  if (time.min === 0 && time.max === 0) {
    return { id: 'in_minutes', key: 'in_minutes', min: 0, max: 0 }
  }
  if (time.min <= 0.5 && time.max <= 0.5) {
    return { id: 'same_day', key: 'same_day', min: 0.5, max: 0.5 }
  }
  if (time.min === 0 && time.max === 1) {
    return { id: 'up_to_one_day', key: 'up_to_one_day', min: 0, max: 1 }
  }
  if (time.min <= 1 && time.max <= 1) {
    return { id: 'next_day', key: 'next_day', min: 1, max: 1 }
  }
  const min = Math.max(1, Math.round(time.min))
  const max = Math.round(time.max)
  if (min === max) {
    return { id: `days_${min}`, key: 'days', min, max }
  }
  return { id: `${min}-${max}`, key: 'from_to_days', min, max }
}

export function compareTransferTime(
  a: { transferTime: { min: number; max: number } },
  b: { transferTime: { min: number; max: number } },
) {
  return (
    a.transferTime.min + a.transferTime.max - (b.transferTime.min + b.transferTime.max) ||
    a.transferTime.max - b.transferTime.max
  )
}
